import { useQuery } from '@tanstack/react-query';

import { accountingService } from '@/services/accounting-service';

const STALE = 30 * 1000;

export function useGlReport(
	params: Parameters<typeof accountingService.reportGlReport>[0] | undefined,
) {
	return useQuery({
		queryKey: ['accounting', 'report', 'gl', params],
		queryFn: () => accountingService.reportGlReport(params!),
		enabled: !!params?.associationId && !!params?.startDate && !!params?.endDate,
		staleTime: STALE,
		retry: 1,
	});
}
